<template>
	<div class="form-group">
		<label v-if="name && hideName === false" class="control-label" :for="uniqueId"> {{ $t('label.' + name) }} <small v-if="crequired">*</small></label>
		<div class="">
				<textarea
					class="form-control"
					:placeholder="placeholder"
					:class="{'is-danger': errors.length > 0}"
					:style="{height: (computedRows * 1.5 + 2.7) + 'em'}"
					:id="uniqueId"
					v-model="internalValue"></textarea>
					<span v-show="errors.length > 0" v-for="error in errors" class="help is-danger">{{ error }}</span>
		</div>
	</div>
</template>

<script>
module.exports = {
	name: 'f-textarea',
	props: {
		value: {type: String, default: ''},
		name: {type: String},
		placeholder: {type: String, default: ''},
		hideName: {type: null, default: false},
		crows: {type: Number, default: 10},
		crequired: {type: Boolean, default: false},
		errors: {type: Array, default: () => ([])}
	},
	data() {
		return {
			uniqueId: 'input-' + Math.random().toString(16).slice(2),
			internalValue: this.value
		};
	},
	computed: {
		computedRows() {
			if (this.crows > 0) {
				return this.crows;
			} else {
				return Math.max(Math.abs(this.crows), this.internalValue.split('\n').length);
			}
		}
	},
	watch: {
		value() {
			this.internalValue = this.value;
		},
		internalValue() {
			this.$emit('input', this.internalValue);
		}
	}
};
</script>



// WEBPACK FOOTER //
// f-textarea.vue?637b3787